import Requestor from '@/api/Requestor';
import { clientInstance } from '@/api/core';
// 세부지명 요청
class RequestMapApi extends Requestor {
    /**
     * 바로고 맵데이터 조회
     * https://dev-zoo-client-api.barogo.io/docs/api-guide.html#_4_27_%EC%A7%80%EB%8F%84_%EB%8D%B0%EC%9D%B4%ED%84%B0_%EC%A1%B0%ED%9A%8C
     */
    getBrgMapAddressList(params) {
        return this.get({
            url: '/api/v2/address',
            params,
        });
    }
    /**
     * 지역 조회 (서울 경기..)
     */
    getAreaList(params = {}) {
        return this.get({
            url: '/api/v2/extra-address/areas',
            params,
        });
    }
    /**
     * 세부지명 요청 리스트 조회
     */
    getItemList(params = {}) {
        return this.get({
            url: '/api/v2/extra-address',
            params,
        });
    }
    /**
     * 요청 단건 취소
     */
    cancelItem(id) {
        return this.delete({
            url: `/api/v2/extra-address/${id}`,
        });
    }
    /**
     * 단건 등록
     */
    postItem(data) {
        return this.post({
            url: '/api/v2/extra-address',
            data,
        });
    }
}
export const requestMapApi = new RequestMapApi(clientInstance);
